import { render, staticRenderFns } from "./avance.vue?vue&type=template&id=5f1223f0&"
import script from "./avance.vue?vue&type=script&lang=js&"
export * from "./avance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports